export default "__VITE_ASSET__D4XJHHJ1__"